export const FUNNEL_STEPS_MAX_COUNT = 5
export const FUNNEL_STEP_FILTER_MAX_COUNT = 5
